export const mutation_add_prestazione = `
mutation addPrestazione($fascicoloId: Int!, $tipoKey: String!, $prestazioneId: Int!, $naturaId: Int!, $scopoId: Int!, $startDate: timestamp!, $endDate: timestamp!, $paeseId: Int!, $provinciaId: Int, $provincia: String!, $cittaId: Int, $citta: String!, $descrizione: String!, $astensioneMotivo: String, $isEsoneroObbAst: Boolean, $isPrivate: Boolean!, $settoreAttivita : String!, $settorePrestazione: String!, $ragione:String!) {
    insert_prestazione_one(object: {FascicoloId: $fascicoloId, TipoKey: $tipoKey, PrestazioneId: $prestazioneId, NaturaId: $naturaId, ScopoId: $scopoId, StartDate: $startDate, EndDate: $endDate, PaeseId: $paeseId, ProvinciaId: $provinciaId, Provincia: $provincia, CittaId: $cittaId, Citta: $citta, Descrizione: $descrizione, AstensioneMotivo: $astensioneMotivo, IsEsoneroObbAst: $isEsoneroObbAst, IsPrivate: $isPrivate, SettoreAttivita : $settoreAttivita, SettorePrestazione: $settorePrestazione, Ragione:$ragione}) {
        Id
        TipoKey
        PrestazioneId
        StartDate
        EndDate
        PaeseId
        ProvinciaId
        Provincia
        CittaId
        Citta
        ScopoId
        NaturaId
        Descrizione
        AstensioneMotivo
        IsEsoneroObbAst
        IsPrivate
        CreatedOn
        ModifiedOn
        CreatedBy
        ModifiedBy
        SettoreAttivita
        SettorePrestazione
        Ragione
        base_tipo_prestazione {
            BaseTenantTipoId
            Nome
            Regole
            Rischio
        }
        prestazione_users {
            Id
            PrestazioneId
            UserId
        }
        rischios(order_by: {Date: desc}) {
            Id
            Date
            DataControlloCostante
            ProvidedBy        
        }
    }
}`;
export const mutation_update_prestazione = `
mutation updatePrestazione($id: Int!, $tipoKey: String!, $prestazioneId: Int!, $naturaId: Int!, $scopoId: Int!, $startDate: timestamp!, $endDate: timestamp!, $paeseId: Int!, $provinciaId: Int, $provincia: String!, $cittaId: Int, $citta: String!, $descrizione: String!, $astensioneMotivo: String, $isEsoneroObbAst: Boolean, $isPrivate: Boolean!, $settoreAttivita : String!, $settorePrestazione: String!, $ragione:String!) {
    update_prestazione(where: {Id: {_eq: $id}}, _set: {TipoKey: $tipoKey, PrestazioneId: $prestazioneId, NaturaId: $naturaId, ScopoId: $scopoId, StartDate: $startDate, EndDate: $endDate, PaeseId: $paeseId, ProvinciaId: $provinciaId, Provincia: $provincia, CittaId: $cittaId, Citta: $citta, Descrizione: $descrizione, AstensioneMotivo: $astensioneMotivo, IsEsoneroObbAst: $isEsoneroObbAst, IsPrivate: $isPrivate,SettoreAttivita : $settoreAttivita, SettorePrestazione: $settorePrestazione, Ragione:$ragione, ModifiedOn: "now()"}) {
        returning {
            Id
            TipoKey
            PrestazioneId
            StartDate
            EndDate
            PaeseId
            ProvinciaId
            Provincia
            CittaId
            Citta
            ScopoId
            NaturaId
            Descrizione
            AstensioneMotivo
            IsEsoneroObbAst
            IsPrivate
            CreatedOn
            ModifiedOn
            CreatedBy
            ModifiedBy
            SettoreAttivita
            SettorePrestazione
            Ragione
            base_tipo_prestazione {
                BaseTenantTipoId
                Nome
                Regole
                Rischio
            }
            prestazione_users {
                Id
                PrestazioneId
                UserId
            }
            prestazione_pagamentos {
                Id
                ValutaId
                ValutaData
                ValutaCambio
                ValutaImporto
                ImportoEuro
                ModalitaPagamentoId
                OrigineId
                CreatedOn
                ModifiedOn
                CreatedBy
                ModifiedBy
                base_valutum {
                    IsoCode
                }
                base_mezzo_pagamento {
                    Value
                }
                base_origine_fondi {
                    Value
                }
            }
            rischios(order_by: {Date: desc}) {
                Id
                Date
                DataControlloCostante
                ProvidedBy
            }
        }
    }
}`;
export const mutation_delete_prestazione = `
mutation deletePrestazione($id: Int!) {
    delete_prestazione(where: {Id: {_eq: $id}}) {
        affected_rows
    }
}`;